import React from 'react'

import HelpIcon from '@material-ui/icons/Help'

export const SyncUnknownIcon = props => <HelpIcon fontSize="small" {...props} />

export default SyncUnknownIcon
